export default function popupFerias() {
  const content = $('[data-ferias="content"]');
  const close = $('[data-ferias="close"]');

  if (!localStorage.getItem('popup')) {
    content.show();
  }

  close.click(() => {
    content.hide();
    localStorage.setItem('popup', true);
  })
}